import type { Me } from '@mollusk/shared';
import { create } from 'zustand';
import { api } from '../api/endpoints';

interface AuthState {
  /** undefined = unknown (loading), null = signed out. */
  me: Me | null | undefined;
  requestLink: (email: string) => Promise<void>;
  verify: (token: string) => Promise<void>;
  acceptTerms: () => Promise<void>;
  logout: () => Promise<void>;
  refresh: () => Promise<void>;
}

export const useAuthStore = create<AuthState>((set, get) => ({
  me: undefined,
  requestLink: async (email) => {
    await api.requestSignInLink(email);
  },
  verify: async (token) => {
    await api.verifySignIn(token);
    await get().refresh();
  },
  acceptTerms: async () => {
    await api.acceptTerms();
    await get().refresh();
  },
  logout: async () => {
    try {
      await api.logout();
    } finally {
      set({ me: null });
    }
  },
  refresh: async () => {
    try {
      set({ me: await api.me() });
    } catch {
      set({ me: null });
    }
  },
}));
